import type { FaireProductEntity } from "../../entity_types/product";

export const p_23yvqq2yn2: FaireProductEntity = {
  token: "p_23yvqq2yn2",
  type: "product",
  name: "Holy Tshili Spicy Everything Chili Crisp",
  brandToken: "b_u3pfx7f42a",
  brandName: "Holy Tshili",
  imageUrl:
    "https://cdn.faire.com/fastly/06239717b231f2a63ec41fcb5fbfb2265fd6328e578d4bfdd77a381109234ed9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13662a6dc17161a004857684adcc7b0d71dd0db94882939d3b2a4a7aa35d94f0.jpeg",
    "https://cdn.faire.com/fastly/7fe64bec6e508604e77f1a4f2387bc422067a8c66b3b71d82f5c01b4d12bcb36.jpeg",
    "https://cdn.faire.com/fastly/10284130265cccc294f13bcd6028551536fb59a6990f136148c219c7541b3a7e.jpeg",
    "https://cdn.faire.com/fastly/939a1a1b46379f875cdce5e04ba54f2949d8dee59660db79f39f4257f8095b51.jpeg",
    "https://cdn.faire.com/fastly/9eb174db9c2dde741b4fda12bed57d2e3fb40a42d83141e9579c28781c6df27e.jpeg",
    "https://cdn.faire.com/fastly/d5b1a87ca1c2329e987dff5dc8f7c69e9273bf6e247a0a3ee9bad1bd85f7b041.jpeg",
  ],
  priceDollars: 9.17,
  description:
    "This is NOT your every day, not-that-crispy, one-note chili\ncrisp! This is the ultimate spicy, fragrant, crispy, chili-jacked, sesame-packed, super-addictive, flavor explosion you need for everything you eat! Holy Tshili Spicy Everything Chili Oil Crisp is packed with a custom blend of crispy, toasty, savory everything bagel seed mix in a perfectly aromatic spicy sesame oil blend to add liberally to your pizza, rice, eggs, pasta, ramen, noodles, dumplings, grits, popcorn, ice cream (yes, ice cream!), and everything else that needs some spicy, chili crisp love!",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:15.593Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
